import { render, staticRenderFns } from "./PersonTypeData.vue?vue&type=template&id=652685e2&"
import script from "./PersonTypeData.vue?vue&type=script&lang=js&"
export * from "./PersonTypeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports